import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RoleGuard} from 'src/app/guards/role.guard';
import {EmplayConsultantComponent} from './components/emplay-consultant/emplay-consultant.component';
import {SolutionsManagerGuard} from 'src/app/guards/solutions-manager.guard';
import {DataManagementGuard} from 'src/app/guards/data-management.guard';
import {DataManagementComponent} from '../data-management/data-management.component';
import {AuthGuard} from "../../guards/auth.guard";

const routes: Routes = [
  {
    path: 'emplay',
    component: EmplayConsultantComponent,
    canActivate: [RoleGuard],
  },
  {
    path: 'data_management',
    component: DataManagementComponent,
    canActivate: [AuthGuard, DataManagementGuard],
    loadChildren: () =>
      import('../../modules/data-management/data-management.module').then(
        (m) => m.DataManagementModule
      ),
  },
  {
    path: 'settings/data_connection',
    canActivate: [AuthGuard, DataManagementGuard],
    loadChildren: () =>
      import('../../modules/data-connection/data-connection.module').then(
        (m) => m.DataConnectionModule
      ),
  },
  {
    path: 'manage-solutions',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () =>
      import('../../modules/sales-dna/sales-dna.module').then(
        (m) => m.SalesDnaModule
      ),
  },
  {
    path: 'solutions-manager',
    canActivate: [AuthGuard, SolutionsManagerGuard],
    loadChildren: () =>
      import('../../modules/solutions-manager/solutions-manager.module').then(
        (m) => m.SolutionsManagerModule
      ),
  },
  {
    path: 'customer',
    canActivate: [AuthGuard, RoleGuard],
    loadChildren: () =>
      import('../../modules/customer-home/customer-home.module').then(
        (m) => m.CustomerHomeModule
      ),
  },
  {
    path: 'sales-rep',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../../modules/sales-rep/sales-rep.module').then(
        (m) => m.SalesRepModule
      ),
  },
  {
    path: 'settings',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('../../modules/settings/settings.module').then(
        (m) => m.SettingsModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeModuleRoutingModule {
}
